import { Button, MenuItem, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { MapEditorObservationPanelEcologicalFunctionTypeFragment } from "./fragments.generated";

type CreateEcologicalFunctionTabProps = {
    onCreate: (ecologicalFunctionTypeId: string) => void;
    ecologicalFunctionTypes: MapEditorObservationPanelEcologicalFunctionTypeFragment[];
};

export default function CreateEcologicalFunctionTab({ onCreate, ecologicalFunctionTypes }: CreateEcologicalFunctionTabProps) {
    const { t } = useTranslation("mapEditor");
    const [selectedTypeId, setSelectedTypeId] = useState(() => ecologicalFunctionTypes?.[0]?.id ?? "");

    const handleCreateClick = () => {
        if (selectedTypeId.length < 1) return;
        onCreate(selectedTypeId);
    };

    return ecologicalFunctionTypes.length > 0 ? (
        <>
            <TextField
                select
                label={t("ecologicalFunctionLinking.labelFunctionType")}
                value={selectedTypeId}
                onChange={e => setSelectedTypeId(e.target.value)}
            >
                {ecologicalFunctionTypes.map(ecologicalFunctionType => (
                    <MenuItem key={ecologicalFunctionType.id} value={ecologicalFunctionType.id}>
                        {ecologicalFunctionType.name}
                    </MenuItem>
                ))}
            </TextField>

            <Button variant="contained" onClick={handleCreateClick} disabled={!selectedTypeId}>
                {t("ecologicalFunctionLinking.btnCreate")}
            </Button>
        </>
    ) : (
        <Typography>{t("ecologicalFunctionLinking.noLinkableFunctionTypes")}</Typography>
    );
}
